import { QueryClient } from 'react-query';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      cacheTime: 300000,
      retry: 1,
    },
  },
});

export default queryClient;
